/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChairIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ChairIcon({
  children,
  viewPath = "/DesignSystem/Svgs/ChairIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="ChairIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-Z191wuN': alignSelf,'--mt-2-Z191wuN': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z191wuN': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z191wuN': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z191wuN': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z191wuN': opacity,'--w-10-Z191wuN': typeof width === 'number' ? `${width}px` : width,'--h-11-Z191wuN': typeof height === 'number' ? `${height}px` : height,'--a-7-Z191wuN': isAnimated ? animation : "none",'--sd-8-Z191wuN': isAnimated ? strokeDashoffset : 0,'--sd-9-Z191wuN': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="ChairIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M16 19v9.4M8.5 28.5h15M3.1 9.3l6.9 9.9h12.3l4.3 4.3"
 style={{'--f-12-Z191wuN': fill,'--s-13-Z191wuN': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}